














import { Component, Prop, Vue } from 'nuxt-property-decorator'
import { mdiStar } from '@mdi/js'
import ComponentIcon from '~/components/icon/icon.vue'
import { filterLinkToProductReviews } from '~/assets/filters/produts'

@Component({
  components: {
    ComponentIcon,
  },
  filters: {
    filterLinkToProductReviews,
  },
})
export default class ComponentRating2 extends Vue {
  @Prop({ type: Number, default: 16 }) private starSize!: number
  @Prop({ type: [String, Number], default: 0 }) private rating!: number | string
  @Prop({ type: [String, Number], default: 0 }) private ratingCount!:
    | number
    | string

  private icons = {
    mdiStar,
  }

  private get styleItem() {
    return {
      height: `${this.starSize}px`,
      width: `${this.starSize}px`,
    }
  }
}
